import { DrillingAreaTeamBase } from './base/drilling-area-team-base';

export class DrillingAreaTeam extends DrillingAreaTeamBase { }